import { useNavigationWithModalCloser } from '../../../utils/contexts/NavigationContext'
import { useOpenFormReplyModal } from '../../../utils/routes/modals/modalsActions'

export const useFormRepliesActions = (item, ids, opts = {}) => {
  const navigate = useNavigationWithModalCloser()

  const openFormReplyModal = useOpenFormReplyModal()

  if (!item && !ids.length) return []

  const singleOptions = [
    {
      value: 'Ver detalhes',
      icon: 'BsSearch',
      onClick: () => openFormReplyModal({ number: item?.number, formId: item?.formId })
    },

    {
      value: 'Gerar PDF',
      icon: 'BsFileRichtext',
      onClick: () => navigate(`/forms/${item?.formId}/pdf/${item?.number}`)
    }
  ]

  const multiOptions = []

  return [!ids || ids.length === 1 ? singleOptions : multiOptions, false]
}
